import React from "react"
import { Pressable, View, Image, Text } from "react-native"

import { mergeDealListWithCartData } from "../../services/oms/OMSCartUtils"
import { getDealDataForCart, getDealPicture, getDealPicturesList, getDealSavingPercent } from "../../services/inventory/DealsUtils"

import { SecondaryCTA } from "../CommonCTA"
import { UpsertCartItemView } from "../UpsertCartItemView"

import { IndiaRupee } from "../../constants/AppConstants"
import { ScreenRoute } from "../../constants/ScreenRouteConstant"

import AppTheme from "../../../AppTheme"
import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"

const DealView = (props) => {
    // Fix it without checking with cart everytime.
    let deal = props.deal
    const dealData = mergeDealListWithCartData({ deals: [deal], cartItemsList: props.cartItems })
    if (dealData.isDealListUpdated) deal = dealData.dealsList[0]
    const index = props.deal.index
    const navigation = props.navigation
    const updateCartDealItem = props.updateCartDealItem
    // const updateCartDealItem = (isAdd, _deal) => {
    //     props.updateCartDealItem(isAdd, props.dealsList, index)
    // }
    return <Pressable key={'dea view: ' + props?.from + '_index_' + index}
        style={[AppStyles.flexRowStart, AppStyles.bgWhite,
        AppStyles.py16, AppStyles.pl16, { width: AppTheme.appWidth, paddingRight: 30, marginBottom: 1 }]}
        onPress={() => {
            if (props?.callback) props.callback()
            navigation.navigate(ScreenRoute.selected_deals, { deal: deal })
        }}>

        <Pressable key={'deal_img_' + deal.dealId}
            onLongPress={() => { console.log('### long press') }}
            onPress={() => {
                let dealPicure = getDealPicture(deal)
                if (dealPicure.preview)
                    props.navigation.navigate(ScreenRoute.images_preview,
                        { imageList: getDealPicturesList(deal) })
            }}><Image source={{ uri: getDealPicture(deal).thumbnail }}
                style={[AppStyles.border4, { width: 90, height: 90 }]} /></Pressable>

        <View style={[AppStyles.ml16,
        { alignItems: "flex-start", width: AppTheme.appWidth - (90 + 32 + 30) }]}>

            <Text style={[TextStyle.text14b, TextStyle.flexWrap, TextStyle.alignLeft]}
                numberOfLines={2} ellipsizeMode={'head'}>{deal.n}</Text>

            {deal.psl || deal._dsp ? <Text style={[TextStyle.text12, TextStyle.alignLeft, {
                marginTop: 6, color: AppTheme.color.grey.text
            }]} numberOfLines={1} ellipsizeMode={'head'}>{ deal.psl ? deal.psl: "*This item is not listed yet but you can add it to cart."}</Text> : null}

            <View style={[AppStyles.mt8, AppStyles.mb16, AppStyles.flexRowStart]}>
                <Text style={[TextStyle.text14b]}>
                    {IndiaRupee}{deal['rp'] ? deal['rp'] : '--'}</Text>
                {deal['rp'] && deal['mrp'] && deal['rp'] != deal['mrp'] ? <Text
                    style={[TextStyle.text12, TextStyle.lineThrough, TextStyle.alignCenter,
                    { marginLeft: 4, color: AppTheme.color.grey.fillerInfo }]}>
                    {IndiaRupee} {deal['mrp']}</Text> : null}
                {!!getDealSavingPercent(deal) ? <Text style={[TextStyle.text12b, { marginLeft: 4, color: AppTheme.color.green.primary }]}>
                    {getDealSavingPercent(deal)}</Text> : null}
            </View>

            {deal.quantity ? <UpsertCartItemView updateCartItem={updateCartDealItem}
                key={'deal_quan_' + deal.dealId} viewStyle={{ marginVertical: 2 }}
                item={getDealDataForCart(deal)} /> :
                <SecondaryCTA action={() => updateCartDealItem(true, getDealDataForCart(deal))}
                    title={'Add To Cart'} width={115} key={'deal_cta_' + deal.dealId}
                    paddingVertical={6} marginAuto={false} borderWidth={1} />}
        </View>
    </Pressable>
}

export default DealView